import { HttpContextToken } from '@angular/common/http';

/**
 * Marca request como não-idempotente — AuthInterceptor pula retry em 502.
 * Use em POSTs/PUTs/DELETEs onde retry duplicaria efeito colateral
 * (criação de Bull job, persistência, integração externa).
 *
 * @example
 *   this.http.post(url, body, {
 *     context: new HttpContext().set(SKIP_RETRY_BAD_GATEWAY, true),
 *   });
 */
export const SKIP_RETRY_BAD_GATEWAY = new HttpContextToken<boolean>(() => false);
